<div class="main-page consultas">
    <div class="container-fluid">
        <div class="row align-items-center">
            <div class="col-12 my-2">
                <h1>
                    <a class="btn btn-voltar text-center mr-2" (click)="this.router.navigate(['/consultations'])"
                        data-title="Voltar"><i class="fas fa-arrow-left"></i></a>
                    Consulta de Regras do Relatorio
                </h1>
            </div>
        </div>
        <div *ngIf="parametersModelPage?.page.totalElements === 0">
            <div class="row no-gutters mt-3">
                <p>Nenhum registro até o momento...</p>
            </div>
        </div>
        <div class="row no-gutters mt-3">
            <div class="mat-elevation table-content">
                <div fxLayout fxLayoutAlign="center center">
                    <mat-form-field fxFlex="10%" class="ml-2">
                        <mat-label>Campo Filtro</mat-label>
                        <mat-select (selectionChange)="this.fieldFilter()" [(value)]="typeFieldFilterSelected"
                            [(ngModel)]="typeFieldFilterSelected">
                            <mat-option *ngFor="let type of typeFieldSelect" [value]="type.value">
                                {{ type.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field fxFlex="40%" class="ml-2">
                        <mat-label>Filtrar</mat-label>
                        <input matInput autocomplete="off" (keyup)="this.applyFilter()" [(ngModel)]="filter"
                            style="text-transform: uppercase;" #input>
                    </mat-form-field>
                </div>
                <table mat-table [dataSource]="parametersTypes" matSort class="mat-elevation-z8">

                    <ng-container matColumnDef="reportTypeName">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome do Tipo do Relatorio</th>
                        <td mat-cell *matCellDef="let element" style="text-transform: uppercase;">{{
                            element.report_type_name}}</td>
                    </ng-container>

                    <ng-container matColumnDef="parametersTypeName">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Descrição da Regra</th>
                        <td mat-cell *matCellDef="let element" style="text-transform: uppercase;">{{
                            element.parameters_type_name }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="valueRule">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Valor da Regra</th>
                        <td mat-cell *matCellDef="let element">{{
                            element.value_rule}}</td>
                    </ng-container>

                    <ng-container matColumnDef="update">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">
                            <span class="alerta mr-2" data-title="Editar" matTooltip="Editar">
                                <a (click)="this.router.navigate(['regra-relatorio/edit/' + element.uuid])"
                                    class="btn btn-link">
                                    <img height="20" src="assets/img/edit.svg" alt="" />
                                </a>
                            </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="delete">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element">
                            <button (click)="handleDelete(element)" class="btn btn-link" matTooltip="Apagar">
                                <img height="20" src="assets/img/trash-cadastro.svg" alt="" />
                            </button>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
                </table>

                <mat-paginator [pageSizeOptions]="[10, 20, 40]" [pageSize]="parametersModelPage.page.size"
                    (page)="onChangePage($event)" [length]="parametersModelPage.page.totalElements"
                    showFirstLastButtons></mat-paginator>
            </div>
        </div>
    </div>
</div>